import { useEffect } from 'react';
import { hookstate, useHookstate } from '@hookstate/core';
import { useRenovacionesFijos } from '~/store/Query/api-renewal';
import { currencyFormat } from '~/helpers/formatter';
import productHelpers from '~/helpers/product';
import { ESPOTS } from '~/store/States/global';
import { AMBOS, CONEQUIPO, SINEQUIPO } from '~/store/States/pospago';

const renewalState = hookstate({
  texto: {
    renewals_modal_nonClaro_description: 'Hemos detectado que tu linea no pertenece a nuestros servicios Claro. ¿Deseas contratar un servicio claro?Continúa para conocer los diferentes Pñanes que tenemos para ti',
    renewals_modal_confirm_invalid: 'PIN inválido, se enviará uno nuevo a tu numero de teléfono',
    renewals_modal_confirm_btnMesssage: 'Validar mi número',
    renewals_modal_confirm_footerText: '¿No has recibido tu PIN? Click aquí para reenviar',
    renewals_modal_prepago_btnMesssage: 'Contratar nuevos servicios',
    renewals_modal_prepago_description: 'Hemos detectado que tu número no aplica para renovación ¿Deseas contratar un servicio postpago claro? Continúa para conocer los diferentes planes que tenemos para ti',
    renewals_modal_nonClaro_btnMesssage: 'Contratar nuevos servicios',
    renewals_modal_agreementExpired_icon: '',
    renewals_modal_prepago_icon: '',
    renewals_modal_confirm_title: 'Confirmación de PIN',
    renewals_modal_confirm_description: 'Ingresa el PIN que enviamos a tu número de teléfono registrado para poder continuar con el proceso de renovación.',
    renewals_modal_payment_title: 'Tienes un pago pendiente',
    renewals_modal_agreementExpired_title: 'Tu contrato aún no vence',
    renewals_modal_agreementExpired_btnMesssage: 'Contratar nuevos servicios',
    modal_token_descripcion: 'Ingresa el PIN que enviamos a tu número de teléfono  registrado para poder continuar el proceso de renovación.',
    pantalla_principal_descripcion: 'Ingresa el número de línea, número de contrato o  factura que deseas renovar para continuar',
    renewals_modal_success_btnMesssage: 'Volver a inicio',
    pantalla_principal_titulo: '¿Deseas renovar tu Línea?',
    pantalla_principal_boton: 'Continuar',
    renewals_modal_success_description: 'En breve un asesor te contactará para completar el proceso de renovación',
    pantalla_principal_placeholder: 'Número a renovar, contrato o factura', //valiar
    pantalla_principal_info_icono: `${ESPOTS}/renovacion_fijos_movil/info_factura.gif`,
    renewals_modal_confirm_icon: '',
    modal_token_titulo: 'Confirmación de PIN',
    modal_token_boton: 'Validar mi número',
    renewals_modal_success_icon: `${process.env.NEXT_PUBLIC_ESPOTS}/renovacion_fijos_movil/Contrato_sinvencer.png`,
    renewals_modal_nonClaro_icon: '',
    renewals_modal_payment_btnLink: 'https://gt.mipagoclaro.com/#/',
    renewals_modal_prepago_title: 'Parece que cuentas con una línea prepago',
    renewals_modal_agreementExpired_description: 'Tu contrato {agreement} aún no aplica para renovación. Te faltan {time} para poder renovar. Si deseas contratar un nuevo servicio, te sugerimos visitar nuestra Tienda en Línea',
    renewals_modal_success_title: '¡Hemos recibido tus datos!',
    renewals_modal_nonClaro_title: 'Parece que no cuentas con servicio Claro',
    renewals_modal_agreementExpired_btnLink: '/categories/postpago/planespostpago',
    renewals_modal_prepago_btnLink: '/categories/postpago/planespostpago',
    renewals_modal_payment_icon: '',
    renewals_modal_nonClaro_btnLink: '/categories/postpago/planespostpago',
    renewals_modal_success_btnLink: '/renewals',
    modal_token_reintentar: '¿No has recibido tu PIN? Click aquí para reenviar',
    renewals_modal_payment_btnMesssage: 'Pagar mi factura',
    renewals_modal_payment_description: 'Tu numero {data} tiene un pago pendiente de {amount}. Para renovar, debes mantener al dia tu cuenta', //validar
    modal_token_error: 'PIN inválido, se enviará uno nuevo a tu número de teléfono',
    renewals_modal_lineaFija_confirm_description: 'Ingresa el número de cualquier de tus ultimas 3 facturas para poder continuar con el proceso de renovación', //validar
    renewals_modal_lineaFija_confirm_title: 'Ingreso de factura',
    renewals_modal_lineaFija_token_boton: 'Validar mi número', //validar
    renewals_modal_lineaFija_token_error: 'Ingresa número de factura', //validar
    renewals_modal_lineaFija_placeholder: 'Ingresa tu número telefonico',
    error_insert_510: 'local Su número de teléfono ya fue ingresado durante el día, en breve nos estaremos comunicando para atender su solicitud.', //validar
    renewals_form_title: 'Hazlo fácil,<span class="d-block d-md-none" /> seguro y ágil',
    renewals_form_btnText: 'Llamarme ahora',
    renewals_form_subtitle: 'Ahora puedes renovar <span class="red-color text-bold d-inline">servicio móvil y servicios fijos sin salir de casa</span>. <br/> Envíanos tus datos y pronto te contactaremos.',
    renewals_form_success: '<span class="black-color fw-normal d-inline">Gracias por ingresar tus datos. </span> <br/><span class="fw-normal d-inline">Muy pronto te estaremos contactando</span>',
    renewals_form_contactPlaceholder: 'Teléfono de contacto',
    renewals_form_namePlaceholder: 'Nombre',
    renewals_form_emailPlaceholder: 'Correo eletrónico [opcional]',
    renewals_form_phonePlaceholder: 'Teléfono de casa [opcional]',
    service_form_type: 'Tipo de servicio',
    service_form_title: 'Servicio a renovar',
    service_form_number: 'Número de telefono',
    modal_service_confirm: 'Confirmar',
    service_form_number_contrato: 'Contrato',
    renewals_modal_billing_image: `${ESPOTS}/renovacion_fijos_movil/billing-ni.png`,
    renewals_modal_billing_description: 'Puedes ingresar un número de factura de las últimas tres (3) facturas emitidas, sin contar la del mes actual.',
    renwals_modal_button_continue: 'Continuar',
    renewals_modal_payment_redirect: '/renewals-plan',
    renewals_modal_paymentNew_description: 'Tu numero tiene un pago pendiente. Continua para renovar', //validar
    renewals_modal_paymentNew_title: 'Tenés un pago pendiente',
    renewals_modal_payment_error_description: 'Tienes un saldo pendiente, te invitamos a pagar para continuar con tu renovación',
    renewals_plans_title: 'Planes sugeridos para ti',
    renewals_current_plan: 'Tu Plan Actual es',
    renewals_current_benefits: 'Cuentas con los siguientes beneficios:',
    renewals_current_internet_fijo: 'Internet',
    renewals_current_minutes_fijo: 'Línea Fija',
    renewals_current_tv: 'TV',
    renewals_current_internet_movil: 'Internet',
    renewals_current_minutes_movil: 'Llamadas y SMS',
    renewals_current_messages: 'SMS',
    renewals_current_price: 'Precio Plan',
    renewals_current_price_suffix: 'mensual',
    renewals_plans_selection_fijo: 'Selecciona alguno de los siguientes planes para mejorar tu servicio Claro Hogar',
    renewals_plans_selection_movil: 'Selecciona alguno de los siguientes planes para mejorar tu servicio Claro Postpago',
    renewals_plans_none: '¿No encuentras el plan que buscas?',
    renewals_mobile_none: '¿No encuentras el smartphone que buscas?',
    renewals_plans_none_description: 'Solicita que un ejecutivo de ventas se comunique contigo para <b>más información</b>',
    renewals_plan_header: 'Mejora tu velocidad',
    renewals_plan_old_fijo: 'Obtienes <b class="datos">{DATOS}Megas</b> de tu plan actual',
    renewals_plan_new_fijo: 'Obtienes <b class="datos">{DATOS}Megas</b> más por <b class="precio">{PRECIO}</b> adicionales',
    renewals_plan_old_movil: 'Obtienes <b class="datos">{DATOS}GB</b> de tu plan actual',
    renewals_plan_new_movil: 'Obtienes <b class="datos">{DATOS}GB</b> más por <b class="precio">{PRECIO}</b> adicionales',
    renewals_plan_old_rent: 'Tu renta se mantiene de',
    renewals_plan_new_rent: 'Tu nueva renta sería de',
    renewals_plan_price_suffix: 'Mensuales',
    renewals_plan_benefits: 'Ver todos los beneficios',
    renewals_plan_button: 'Mejorar mi Plan',
    renewals_mobile_title: 'Smartphones con tu Plan Postpago',
    renewals_selected_plan: 'Tu plan seleccionado es:',
    renewals_selected_plan_benefits: 'Tus nuevos beneficios serán:',
    renewals_selected_plan_plazo: 'Elige plazo',
    renewals_selected_plan_social: 'Redes Ilimitadas',
    renewals_form_title_fijo: 'Completa la mejora de tu plan Claro Hogar',
    renewals_form_title_fijo_no: 'Completa la solicitud para tu plan Claro hogar',
    renewals_form_title_movil: 'Completa la mejora de tu Plan Postpago',
    renewals_form_title_movil_no: 'Completa la solicitud para tu Plan Postpago',
    renewals_form_total: 'TOTAL',
    renewals_form_cambiar: 'Cambiar selección',
    renewals_form_mobile_price_prefix: 'Prima',
  },
});

export const useRenewalState = () => {
  const config = useRenovacionesFijos();
  useEffect(() => {
    if (config.data?.ok) {
      const info = config.data.body.data;
      renewalState.merge({
        ...renewalState.value,
        ...info,
        texto: {
          ...renewalState.texto.value,
          ...info.texto,
        },
      });
    }
  }, [config.data]);
  return useHookstate(renewalState);
};

export const clearNumber = () => {
  sessionStorage.removeItem('renewals.phonePostPago');
  sessionStorage.removeItem('renewals.phoneHouse');
  sessionStorage.removeItem('renewals.phoneBill');
  sessionStorage.removeItem('renewals.isPostPago');
  sessionStorage.removeItem('renewals.plan');
  sessionStorage.removeItem('renewals.planName');
  sessionStorage.removeItem('renewals.planPrice');
  sessionStorage.removeItem('renewals.mobile');
  sessionStorage.removeItem('renewals.mobileName');
  sessionStorage.removeItem('renewals.mobilePrice');
  sessionStorage.removeItem('renewals.feePrice');
  sessionStorage.removeItem('renewals.clientName');
  sessionStorage.removeItem('renewals.clientLastName');
  sessionStorage.removeItem('renewals.mock');
};

export const productInfo = (item, tipo) => {
  const attrMap = productHelpers.convertAttributes(item.attributes);
  const name = (attrMap['attr-conf-nombre-renovacion'] || item.locales[process.env.NEXT_PUBLIC_LOCALE].name).replace(/<br>|<br\/>|\\n/g, '\n');
  const simplename = name.replace(/\n/g, '');
  let offer = item.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price / 100;
  const detalle = {
    datos: attrMap['attr-detalle-ancho-banda-renovacion'],
    internet: attrMap['attr-detalle-internet-renovacion'],
    llamadas: attrMap['attr-detalle-llamadas-renovacion'],
    tvsms: attrMap['attr-detalle-tv-sms-renovacion'],
  };
  if (tipo === 'movil') {
    offer = +(attrMap['attr-conf-precio-mensual-renovacion'] || attrMap['attr-conf-precio-mensual']);
  }
  const format = currencyFormat(offer, 1);
  return {
    name,
    simplename,
    offer,
    format,
    detalle,
    attrMap,
  };
};

export const getType = () => {
  if (sessionStorage.getItem('renewals.modalidadPostPago') === AMBOS) {
    return sessionStorage.getItem('renewals.currentType') === CONEQUIPO;
  } else {
    return sessionStorage.getItem('renewals.modalidadPostPago') !== SINEQUIPO;
  }
};
